import { Select } from 'antd';

import { DEFAULT_RATING_MAX, RATING_SCALE_CHOICES, ratingScale } from '../../utils/rating';

/**
 * The card-definition sub-editor for a `rating` element's scale
 * (docs/plans/data-types-second-pass.md §3.1, decision D13):
 *
 *   max   how many stars the rating is out of — 2 to 10, default 5. The API
 *         holds every write to it (400 `range` past it) and refuses a scale
 *         outside 2–10 (400 `invalid_options`).
 *
 * Half stars are the "Allow half stars" toggle row beside the other
 * switches (elementOptionPolicy ELEMENT_OPTION_TOGGLES), so this panel is the
 * one Select. A scale stored before the 2–10 rule (an API-key author's 20)
 * is shown as it is, so the author can see what the card holds and pick a
 * scale the save accepts.
 *
 * Writes go through the form's path-based onChange (`elements[i].options.x`);
 * this editor holds no state of its own.
 */
export default function RatingOptions({ index, element, onChange, basePath = null }) {
	const prefix = `${basePath || `elements[${index}]`}.options`;
	const { max } = ratingScale(element?.options);
	const choices = RATING_SCALE_CHOICES.includes(max) ? RATING_SCALE_CHOICES : [...RATING_SCALE_CHOICES, max];

	return (
		<div className='rating-options'>
			<div className='micro-label card-def-element__section'>Rating</div>
			<div className='mb-2'>
				<label className='d-block' htmlFor={`${prefix}.max`}>Stars</label>
				<Select
					id={`${prefix}.max`}
					size='large'
					className='w-100'
					value={max}
					onChange={next => onChange(`${prefix}.max`, next)}
					options={choices.map(n => ({ value: n, label: n === DEFAULT_RATING_MAX ? `${n} stars (default)` : `${n} stars` }))}
					aria-label='Stars'
				/>
				<div className='form-panel__hint'>
					How many stars a rating is out of. Lists and exports show the number beside the stars when it is not 5.
				</div>
			</div>
		</div>
	);
}
